import React, { useCallback, useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

import {
  FaTachometerAlt,
  FaImages,
  FaUsers,
  FaUserTie,
  FaBoxOpen,
  FaBriefcase,
  FaPhotoVideo,
  FaYoutube,
  FaAddressBook,
  FaClipboardList,
  FaPuzzlePiece,
  FaSignOutAlt,
} from "react-icons/fa";

import { BASE_URL } from "../../Config/config";
import "./Sidebar.css";

export default function Sidebar() {
  const navigate = useNavigate();

  const [inquiryCount, setInquiryCount] = useState(0);

  /* =========================================================
     FETCH NEW INQUIRY COUNT
  ========================================================= */

  const fetchInquiryCount = useCallback(async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/dashboard.php?action=get_new_inquiries_count`,
      );

      if (!response.ok) {
        return;
      }

      const result = await response.json();

      if (result.status) {
        setInquiryCount(Number(result.data?.count || 0));
      }
    } catch (error) {
      console.error("Inquiry count error:", error);
    }
  }, [BASE_URL]);

  /* =========================================================
     INITIAL COUNT
  ========================================================= */

  useEffect(() => {
    fetchInquiryCount();
  }, [fetchInquiryCount]);

  /* =========================================================
     MARK INQUIRIES AS SEEN
  ========================================================= */

  const handleInquiryClick = async () => {
    try {
      if (inquiryCount > 0) {
        const response = await fetch(
          `${BASE_URL}/dashboard.php?action=mark_inquiries_seen`,
          {
            method: "POST",
          },
        );

        const result = await response.json();

        if (result.status) {
          setInquiryCount(0);
        }
      }
    } catch (error) {
      console.error("Failed to update inquiry status:", error);
    }
  };

  /* =========================================================
     LOGOUT
  ========================================================= */

  const handleLogout = () => {
    // Remove admin session
    sessionStorage.removeItem("admin_logged_in");
    sessionStorage.removeItem("admin_id");
    sessionStorage.removeItem("admin_username");
    sessionStorage.removeItem("admin_name");
    sessionStorage.removeItem("admin_email");

    // Also remove old localStorage authentication
    // in case an older login was stored there.
    localStorage.removeItem("adminUser");
    localStorage.removeItem("adminLogin");

    // Redirect to admin login
    navigate("/MyAdminStar/login", { replace: true });
  };

  /* =========================================================
     MENU ITEMS
  ========================================================= */

  const menuItems = [
    {
      path: "/MyAdminStar/dashboard",
      label: "Dashboard",
      icon: <FaTachometerAlt />,
    },

    {
      path: "/MyAdminStar/homepageimages",
      label: "Home Page Images",
      icon: <FaImages />,
    },

    {
      path: "/MyAdminStar/teams",
      label: "Teams",
      icon: <FaUsers />,
    },

    {
      path: "/MyAdminStar/company-clients",
      label: "Company Clients",
      icon: <FaUserTie />,
    },

    {
      path: "/MyAdminStar/youtube-videos",
      label: "YouTube Videos",
      icon: <FaYoutube />,
    },

    {
      path: "/MyAdminStar/products",
      label: "Products",
      icon: <FaBoxOpen />,
    },

    {
      path: "/MyAdminStar/modules",
      label: "Tally Modules",
      icon: <FaPuzzlePiece />,
    },

    {
      path: "/MyAdminStar/services",
      label: "Services",
      icon: <FaBriefcase />,
    },
    {
      path: "/MyAdminStar/about",
      label: "About Page Images",
      icon: <FaImages />,
    },
    {
      path: "/MyAdminStar/gallery",
      label: "Gallery",
      icon: <FaPhotoVideo />,
    },

    {
      path: "/MyAdminStar/contacts",
      label: "Contacts",
      icon: <FaAddressBook />,
    },
  ];

  return (
    <aside className="sidebar">
      {/* =====================================================
          LOGO
      ===================================================== */}

      <div className="sidebar-logo">
        {/* <div className="logo-icon">SC</div> */}
        <img
          src="/favicon.ico"
          alt="Star Computers & Information Technology"
          className="logo"
        />

        <div className="logo-text">
          <h2>Star Computers</h2>

          <span>Admin Panel</span>
        </div>
      </div>

      {/* =====================================================
          NAVIGATION
      ===================================================== */}

      <nav className="sidebar-nav">
        <p className="nav-title">MAIN MENU</p>

        {menuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `sidebar-link ${isActive ? "active" : ""}`
            }
          >
            {item.icon}

            <span>{item.label}</span>
          </NavLink>
        ))}

        {/* ===================================================
            INQUIRY
        =================================================== */}

        <NavLink
          to="/MyAdminStar/inquiry"
          onClick={handleInquiryClick}
          className={({ isActive }) =>
            `sidebar-link ${isActive ? "active" : ""}`
          }
        >
          <div className="sidebar-inquiry-icon">
            <FaClipboardList />

            {inquiryCount > 0 && (
              <span className="sidebar-inquiry-badge">
                {inquiryCount > 99 ? "99+" : inquiryCount}
              </span>
            )}
          </div>

          <span>Inquiry</span>
        </NavLink>
      </nav>

      {/* =====================================================
          BOTTOM
      ===================================================== */}

      <div className="sidebar-bottom">
        {/* ADMIN PROFILE */}

        <div className="admin-profile">
          <div className="admin-avatar">
            {(sessionStorage.getItem("admin_name") || "A")
              .charAt(0)
              .toUpperCase()}
          </div>

          <div>
            <strong>
              {sessionStorage.getItem("admin_name") || "Administrator"}
            </strong>

            <small>Super Admin</small>
          </div>
        </div>

        {/* LOGOUT */}

        <button type="button" className="logout-btn" onClick={handleLogout}>
          <FaSignOutAlt />

          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
}
